module.exports = __webpack_public_path__ + "static/media/app2.a4cca655.png";